import { SearchOutlined } from '@ant-design/icons';
import { Col, Input, Row, Select, Space } from 'antd';
import { FC } from 'react';
import styles from './index.module.scss';

interface SearchAndFilterProps {
    performSearchHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
    searchValue: string;
    performFilterHandler: (value: string) => void;
    filterValue: string;
}

const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
    const { performSearchHandler, searchValue, performFilterHandler, filterValue } =
        props;

    return (
        <div className={styles['search-filter']}>
            <div className={styles['search-filter__wrapper']}>
                <Row>
                    <Col>
                        <Space>
                            <Input
                                className={styles['search-filter__search']}
                                placeholder="Search employee"
                                suffix={<SearchOutlined />}
                                onChange={performSearchHandler}
                                value={searchValue}
                                size="large"
                            />
                            <Select
                                value={filterValue || 'all'}
                                style={{ width: 200 }}
                                onChange={performFilterHandler}
                                options={[
                                    { label: 'All', value: 'all' },
                                    { label: 'Active', value: 'active' },
                                    { label: 'Inactive', value: 'inactive' },
                                ]}
                                size="large"
                            />
                        </Space>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default SearchAndFilter;

